import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

class RateConflictsModal extends Component {
  render() {
    const { showBrowserModal, closeModal, details, handleSave, handleCancel } = this.props;
    return (
      <Modal lg={"medium"} show={showBrowserModal} onHide={closeModal}>
       <Modal.Header className="no-border" style={{ paddingBottom: '5px', marginBottom: '0' }}>
  <h4 className="m-0 font-weight-bold" style={{ marginBottom: '0' }}>
    {details.title}
  </h4>
  <Button
    title={"Warning"}
    type="button"
    onClick={closeModal}
    className="close-btn"
    data-dismiss="modal"
  >
    <i className="nc-icon nc-simple-remove"></i>
  </Button>
</Modal.Header>

      <Modal.Body style={{ padding: '12px 20px 16px' }}>
  <div style={{ 
    whiteSpace: 'pre-line', 
    lineHeight: 1.4, 
    margin: 0 
  }}>
    <div>{details?.message || ""}</div>
  </div>
</Modal.Body>



        <Modal.Footer>

          <Button
            style={{ minWidth: "93px" }}
            onClick={handleSave}
            type="button"
            className="btn btn-fill btn-info"
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RateConflictsModal;
